import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CardStatus,
  CustomerCard,
  OrderCardFormValues,
} from '../../../../customers/types';

export interface CorporateCustomerCards {
  cards?: CustomerCard[];
  isLoading: boolean;
  statusChangeInProgress?: boolean;
  updatedCard?: {
    id: string;
    status: CardStatus;
  };
  cardInfo?: CustomerCard;
  orderCardFormValues?: OrderCardFormValues;
  cardSubmitInProgress?: boolean;
  cardSubmitSuccess?: boolean;
  changeStatusSuccess?: boolean;
  cardInfoLoading?: boolean;
  cardId?: string;
}

const initialState: CorporateCustomerCards = {
  isLoading: false,
};

export const corporateCustomerCardsSlice = createSlice({
  name: 'corporateCustomerCards',
  initialState,
  reducers: {
    getCards: (state) => {
      state.isLoading = true;
    },
    getCardsSuccess: (state, action: PayloadAction<CustomerCard[]>) => {
      state.isLoading = false;
      state.cards = action.payload;
    },
    onCardStatusChange: (
      state,
      action: PayloadAction<{ id: string; status: CardStatus }>,
    ) => {
      state.statusChangeInProgress = true;
      state.updatedCard = action.payload;
      state.changeStatusSuccess = false;
    },
    getCardInfo: (state, action: PayloadAction<string>) => {
      state.cardId = action.payload;
      state.cardInfoLoading = true;
    },
    getCardInfoSuccess: (state, action: PayloadAction<CustomerCard>) => {
      state.cardInfo = action.payload;
      state.cardInfoLoading = false;
    },
    onSubmitCard: (state, action: PayloadAction<OrderCardFormValues>) => {
      state.orderCardFormValues = action.payload;
      state.cardSubmitInProgress = true;
    },
    onSubmitCardSuccess: (state, action: PayloadAction<CustomerCard[]>) => {
      state.cardSubmitInProgress = false;

      state.cards = action.payload;

      state.cardSubmitSuccess = true;
    },
    onCardStatusChangeSuccess: (
      state,
      action: PayloadAction<CustomerCard[]>,
    ) => {
      state.statusChangeInProgress = false;
      state.updatedCard = undefined;
      state.cards = action.payload;
    },
    clearCardsState: (state) => {
      state.isLoading = true;
    },
    clearOrderCardForm: (state) => {
      state.orderCardFormValues = undefined;
      state.cardSubmitSuccess = false;
      state.cardId = undefined;
      state.cardInfo = undefined;
    },
  },
});

export const {
  getCards,
  getCardsSuccess,
  onCardStatusChange,
  onCardStatusChangeSuccess,
  clearCardsState,
  getCardInfo,
  getCardInfoSuccess,
  onSubmitCard,
  clearOrderCardForm,
  onSubmitCardSuccess,
} = corporateCustomerCardsSlice.actions;

export default corporateCustomerCardsSlice.reducer;
